import { defineFcm } from '../shared/factory';

export const FCM_SIGNER_EMAIL_IN_SIGNATURE_EXPORT = defineFcm('signer_email_in_signature_export')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-dolphin',
		scope: 'export-service',
		context: 'Export Service',
		description:
			'Controls whether the signer email is included in the signature export (if they consented, i.e. if an OrganizationEmailSubscription is present).',
		import: false,
	});
